import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = 'https://vncqadrzcspfqrmqhula.supabase.co';
const SUPABASE_KEY = 'sb_publishable_G3OQF5A4NgUXCA8-CkK4bg_PV1vt_KT';

// Se captura ANTES de crear el cliente: supabase-js limpia el hash de la URL al procesarlo,
// y el evento PASSWORD_RECOVERY puede dispararse antes de que la pantalla de login esté montada.
const _h = typeof window !== 'undefined' ? window.location.hash : '';
export const ENLACE_RECUPERACION = /type=recovery/.test(_h);
export const ENLACE_EXPIRADO = /error_code=otp_expired|error=access_denied/.test(_h);

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);